import React, { forwardRef } from "react";
import { View, Text, Image, Pressable, Animated } from "react-native";
import { Entypo, Ionicons, AntDesign } from '@expo/vector-icons';
import MaskedView from '@react-native-masked-view/masked-view';
import { LinearGradient } from 'expo-linear-gradient';
import * as Animatable from 'react-native-animatable';
import styles from "@stylesheet";
import { useNavigation } from "@react-navigation/native";
import AchievementBackground from "@assets/--native/AchievementBackground";
import moment from "moment";
import parseByDelimiter from "@utils/parseByDelimiter";

import { PreviewModalHandler } from "./PreviewModal";
import { useDeviceType } from "@hooks/useDeviceType";
import { DefaultRootState } from "@reduxLocal/persistState";
import { useSelector } from "react-redux";

interface CompanyEmailItemProps {
  item: any;
  index: number;
}


const CompanyEmailItem = forwardRef<PreviewModalHandler, CompanyEmailItemProps>((props, ref) => {
  const { item, index } = props;
  const navigation = useNavigation();
  const { isTablet } = useDeviceType();
  const tablet = isTablet;
    const globalDate = useSelector((state:DefaultRootState) => state.UI.dateFormat);
  

  return (
    <View style={{ flex: 1, flexDirection: "column", gap: 5, minHeight: 300, paddingVertical: 10 }}>
      <View style={{ margin: 10, flex: 6, shadowRadius: 20, shadowOpacity: .2, borderRadius: 10, minWidth: 180 }}>
        <Image source={{ uri: item.snapShot }} style={{ borderRadius: 10, resizeMode: "contain", minWidth: "100%", flex: 1, }} />
      </View>
      <View style={{ flex: 2, flexDirection: "row", gap: 15 }}>
        <Animatable.View useNativeDriver delay={index * 200} animation={'bounceIn'} style={[styles.noteContainer, { paddingRight: 15, flex: 1, overflow: 'hidden', alignSelf: 'stretch', padding: 10, gap: 5, flexDirection: 'column' }]}>
          <AchievementBackground green={item.type === 'project'} style={{ position: 'absolute', overflow: 'hidden', minWidth: '100%', opacity: 1, zIndex: -1, transform: [{ scale: tablet ? 20 : 10 }] }} />
          <View style={{ flexDirection: 'row', alignContent: 'space-around', minWidth: '100%' }}>
            <View style={{ alignSelf: 'flex-start', flex: 10, gap: 10 }}>
              <Text adjustsFontSizeToFit style={{ color: 'white', fontWeight: 'bold' }} numberOfLines={1}>{parseByDelimiter(item.title)}</Text>
              <Text style={{ color: "white" }}>{moment(item.createdAt).format(globalDate)}</Text>
            </View>
          </View>
        </Animatable.View>
        <Pressable onPress={() => navigation.navigate('PreviewEmailTemplate', { templateId: item._id })} style={[styles.centerEverything, { position:"absolute", right: -30, width: 50, height: 50, backgroundColor: "rgb(90,192,234)", borderRadius: 50 }]} >
          <Ionicons name="chevron-forward" size={40} style={{ top: 5 }} color="white" />
        </Pressable>
      </View>
    </View>
  )
});
export default CompanyEmailItem;